import "./App.css";
import { Routes, Route, Link } from "react-router-dom";
import Imprint from "./pages/Imprint";
import Home from "./pages/Home";

function App() {
  return (
    <div className="site">
      <header className="site-header">
        <div className="container header-content">
          <div className="brand">
            <span className="brand-mark">U&amp;H</span>
            <span className="brand-name">Ulrich &amp; Hellenbrand GbR</span>
          </div>
        </div>
      </header>

      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/imprint" element={<Imprint />} />
        </Routes>
      </main>

      <footer className="site-footer">
        <div className="container footer-content">
          <span>© {new Date().getFullYear()} Ulrich &amp; Hellenbrand GbR</span>
          <div className="footer-links">
            <Link to="/imprint">Imprint</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
